import {globals} from '@extensions/globals-base'
import {DataObjectId, DeadlineStickerEntry, JSONLike} from 'yougile-model'
import {Time, parseDateTime} from 'yougile-util'
import {COLUMN_NAMES} from '../constants'
import {Row, State} from '../types'
import {getUserIdByEmail} from './utils/get-user-id-by-email'
import {addToCheckProcessedColumn} from './utils/add-to-check-processed-column'
import {getRowValue} from './utils/get-row-value'

export const getStickers = (
  state: State,
  row: Row
): Record<string, JSONLike> => {
  const taskDeadline = getRowValue(state, row, COLUMN_NAMES.DEADLINE)
  const taskStartDate = getRowValue(state, row, COLUMN_NAMES.START_DATE)

  const stickers: {[id: string]: JSONLike} = {}
  if (taskDeadline) {
    addToCheckProcessedColumn(state, COLUMN_NAMES.DEADLINE)
    addToCheckProcessedColumn(state, COLUMN_NAMES.START_DATE)
    const timeNow = Time.now()
    const deadline: DeadlineStickerEntry = {
      deadline: parseDateTime(taskDeadline) || timeNow,
      startDate: parseDateTime(taskStartDate) || timeNow,
      timestamp: timeNow,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      by: globals.currentUserId as DataObjectId
    }

    stickers.deadline = deadline
  }

  const taskAssigned = getRowValue(state, row, COLUMN_NAMES.ASSIGNED)
  if (taskAssigned) {
    addToCheckProcessedColumn(state, COLUMN_NAMES.ASSIGNED)
    const user = getUserIdByEmail(taskAssigned)
    if (user) {
      stickers.assigned = [user.id] as DataObjectId[]
    }
  }

  return stickers
}
